<template>
  <li>
    {{ item.date }} &ndash;
    {{ item.what }} {{ item.action }} &ndash;
    <template v-if="affectingFinalPayment">
      Final &ndash;
    </template>
    <template v-else-if="affectingDepositPayment">
      Deposit &ndash;
    </template>
    {{ responsible }}
    <p v-for="(item, key, index) in to" :key="index" class="change">
      <strong>
        {{ key }}:
      </strong>
      <template v-if="from[key]">
        "{{ from[key] }}"
      </template>
      <template v-if="to">
        <strong v-if="from[key]">to</strong> "{{ item }}"
      </template>
    </p>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },

  computed: {
    responsible () {
      return this.item.responsible || 'System'
    },

    what () {
      return this.item.what
    },

    from () {
      return this.item.from
    },

    to () {
      return this.item.to
    },

    affectingFinalPayment () {
      return this.what === 'payment' &&
        this.item.related.type === 'final'
    },

    affectingDepositPayment () {
      return this.what === 'payment' &&
        this.item.related.type === 'deposit'
    }
  }
}
</script>
